import { render, staticRenderFns } from "./digitalMarketingListing.vue?vue&type=template&id=6a40bef0&scoped=true"
import script from "./digitalMarketingListing.vue?vue&type=script&lang=js"
export * from "./digitalMarketingListing.vue?vue&type=script&lang=js"
import style0 from "./digitalMarketingListing.vue?vue&type=style&index=0&id=6a40bef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a40bef0",
  null
  
)

export default component.exports